export const LOGIN_INIT = 'LOGIN_INIT';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_REQUEST_RESET_PASSWORD_INIT = 'LOGIN_REQUEST_RESET_PASSWORD_INIT';
export const LOGIN_REQUEST_RESET_PASSWORD_SUCCESS = 'LOGIN_REQUEST_RESET_PASSWORD_SUCCESS';
export const LOGIN_REQUEST_RESET_PASSWORD_FAILURE = 'LOGIN_REQUEST_RESET_PASSWORD_FAILURE';
export const LOGIN_REQUEST_RESET_PASSWORD_RESET = 'LOGIN_REQUEST_RESET_PASSWORD_RESET';
export const LOGIN_RESET = 'LOGIN_RESET';


// WEBPACK FOOTER //
// ./source/client/actions/login/types.js